export default '<span class="inlineSpinner mRs"></span>';
